type Logo =
  | "kdb"
  | "front1"
  | "hybe"
  | "lguplus"
  | "wework"
  | "zigbang"
  | "weverse"
  | "lginnotek"
  | "justco"
  | "tiktok"
  | "genstarmate"
  | "ridi"
  | "sparkplus"
  | "handsome"
  | "trip"
  | "blt"
  | "alexmuller"
  | "visionport"
  | "lgcns"
  | "dcamp"
  | "inno.n"
  | "wtcseoul"
  | "shoplive"
  | "saintlaurent"
  | "qraft"
  | "pivotpoint"
  | "milimeal"
  | "lgsports"
  | "goldenplanet"
  | "genuonesciences"
  | "cummins"
  | "42dot"
  | "shinhansec"
  | "hanlim"
  | ""; // 지점 로고가 없는 경우
export type CenterType = "Plus" | "Basic" | "Fit"; // 지점구분
// 운영서비스
type Service =
  | "택배"
  | "퀵"
  | "등기"
  | "EMS"
  | "DHL"
  | "행낭"
  | "냉장보관"
  | "포장용품판매"
  | "법인인감"
  | "A4용지 판매"
  | "국제우편";

type WorkTimeRange = { startTime: string; endTime: string };

export interface Center {
  logo: Logo;
  name: string;
  type: CenterType;
  address: string;
  detailAddress: string;
  coords: number[];
  call: string;
  time: {
    weekday: WorkTimeRange; // [0]: 시작시간, [1]: 종료시간
    lunch?: WorkTimeRange; // [0]: 시작시간, [1]: 종료시간
    saturday?: WorkTimeRange;
  };
  service: Service[];
}

export const centerList: Center[] = [
  {
    logo: "genstarmate",
    name: "디포스트 KDB생명타워",
    type: "Plus",
    address: "서울특별시 용산구 한강대로 372 KDB생명타워",
    detailAddress: "B111, KDB생명타워 메일룸 디포스트",
    coords: [37.5516, 126.9729],
    call: "01082744805",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "냉장보관", "포장용품판매"],
  },
  {
    logo: "lginnotek",
    name: "이노메일센터 디포스트 파주",
    type: "Fit",
    address: "경기도 파주시 문산읍 휴암로 570 LG이노텍 경비동",
    detailAddress: " 1층, 이노메일센터 디포스트",
    coords: [37.8411, 126.7792],
    call: "01083254805",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "weverse",
    name: "디포스트 위버스 컴퍼니",
    type: "Fit",
    address: "경기도 성남시 분당구 분당내곡로 131 판교테크윈타워1",
    detailAddress: "6층, 위버스 메일룸 디포스트",
    coords: [37.3954, 127.1121],
    call: "01076124805",
    time: {
      weekday: { startTime: "10:00", endTime: "19:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "등기", "EMS", "DHL"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 삼성역",
    type: "Plus",
    address: "서울특별시 강남구 테헤란로 507 WeWork빌딩",
    detailAddress: "지하 1층, 위워크 메일룸 디포스트",
    coords: [37.5076, 127.0577],
    call: "01082904805",
    time: {
      weekday: { startTime: "13:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 삼성역2",
    type: "Plus",
    address: "서울특별시 강남구 테헤란로 518 한국섬유산업연합회",
    detailAddress: "10층, 위워크 메일룸 디포스트",
    coords: [37.5076, 127.0605],
    call: "01066584805",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "등기", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 서울스퀘어",
    type: "Plus",
    address: "서울특별시 중구 한강대로 416 서울스퀘어",
    detailAddress: "13층, 위워크 메일룸 디포스트",
    coords: [37.5555, 126.9738],
    call: "01077344805",
    time: {
      weekday: { startTime: "13:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 선릉",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로 302 위워크타워",
    detailAddress: "지하 1층, 디포스트 무인발송 스테이션",
    coords: [37.5024, 127.0434],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 선릉2",
    type: "Plus",
    address: "서울특별시 강남구 테헤란로 427 위워크타워",
    detailAddress: "1층, 위워크 메일룸 디포스트",
    coords: [37.5063, 127.0536],
    call: "01066594805",
    time: {
      weekday: { startTime: "13:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 선릉3",
    type: "Plus",
    address: "서울특별 강남구 선릉로 428",
    detailAddress: "2층, 위워크 메일룸 디포스트",
    coords: [37.5034, 127.0498],
    call: "01082714805",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "등기", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 여의도역",
    type: "Plus",
    address: "서울특별시 영등포구 사당대로 83 오투타워",
    detailAddress: "20층, 위워크 메일룸 디포스트",
    coords: [37.5233, 126.9234],
    call: "01075894805",
    time: {
      weekday: { startTime: "13:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 역삼역",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로 142 캐피탈타워",
    detailAddress: "3층, 디포스트 무인발송 스테이션",
    coords: [37.4997, 127.0349],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "lguplus",
    name: "LG U+업무지원센터 마곡",
    type: "Fit",
    address: "서울특별시 강서구 마곡중앙8로 71 LG사이언스파크",
    detailAddress: "지하 1층, 업무지원센터 디포스트",
    coords: [37.5619, 126.8345],
    call: "07040809287",
    time: {
      weekday: { startTime: "08:30", endTime: "18:30" },
    },
    service: ["택배", "퀵", "등기", "행낭", "EMS", "포장용품판매"],
  },
  {
    logo: "lguplus",
    name: "LG U+업무지원센터 상암",
    type: "Fit",
    address: "서울특별시 마포구 월드컵북로416 LG유플러스 상암사옥",
    detailAddress: "지하 1층, 업무지원센터 디포스트",
    coords: [37.5805, 126.8877],
    call: "0269201414",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "등기", "행낭", "냉장보관", "포장용품판매"],
  },
  {
    logo: "lguplus",
    name: "LG U+업무지원센터 서울역빌딩",
    type: "Fit",
    address: "서울특별시 중구 후암로 98 LG서울역빌딩",
    detailAddress: "17층, 업무지원센터 디포스트",
    coords: [37.5539, 126.9748],
    call: "01082174805",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "등기", "행낭", "포장용품판매"],
  },
  {
    logo: "lguplus",
    name: "LG U+업무지원센터 용산",
    type: "Fit",
    address: "서울특별시 용산구 한강대로32 LG유플러스",
    detailAddress: "지하 1층, 업무지원센터 디포스트",
    coords: [37.5238, 126.9636],
    call: "07040809274",
    time: {
      weekday: { startTime: "08:30", endTime: "18:30" },
    },
    service: ["택배", "퀵", "등기", "행낭", "EMS", "냉장보관", "포장용품판매"],
  },
  {
    logo: "justco",
    name: "디포스트 저스트코타워",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로 431 저스트코타워",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.5065, 127.0543],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "zigbang",
    name: "디포스트 직방 컨시어지",
    type: "Plus",
    address: "서울특별시 강남구 역삼로17길 64 JESS빌딩",
    detailAddress: "4층 2호, 직방 컨시어지 메일룸 디포스트",
    coords: [37.4988, 127.0366],
    call: "01082914805",
    time: {
      weekday: { startTime: "09:30", endTime: "18:30" },
      lunch: { startTime: "13:00", endTime: "14:00" },
    },
    service: ["택배", "퀵", "포장용품판매"],
  },
  {
    logo: "genstarmate",
    name: "디포스트 페럼타워",
    type: "Plus",
    address: "서울특별시 중구 을지로5길 19 FERRUM TOWER",
    detailAddress: "지하 1층, 페럼타워 메일룸 디포스트",
    coords: [37.5669, 126.984],
    call: "01082394805",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "포장용품판매"],
  },
  {
    logo: "front1",
    name: "디포스트 프론트원",
    type: "Fit",
    address: "서울특별시 마포구 마포대로 122 신용보증기금빌딩",
    detailAddress: "1층, 프론트원 메일룸 디포스트",
    coords: [37.5454, 126.9525],
    call: "01077064805",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: [
      "택배",
      "퀵",
      "등기",
      "법인인감",
      "냉장보관",
      "포장용품판매",
      "A4용지 판매",
    ],
  },
  {
    logo: "hybe",
    name: "디포스트 하이브",
    type: "Fit",
    address: "서울특별시 용산구 한강대로 42 HYBE",
    detailAddress: "1층, 하이브 메일룸 디포스트",
    coords: [37.5247, 126.9643],
    call: "01084214805",
    time: {
      weekday: { startTime: "10:00", endTime: "19:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵", "등기", "EMS", "DHL"],
  },
  {
    logo: "ridi",
    name: "디포스트 리디주식회사",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로 325 URBAN BENCH",
    detailAddress: "4층, 디포스트 무인발송 스테이션",
    coords: [37.5042, 127.0468],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기", "EMS"],
  },
  //10.01 오픈 지점
  {
    logo: "wework",
    name: "디포스트 위워크 강남역",
    type: "Plus",
    address: "서울특별시 서초구 강남대로 373 홍우빌딩",
    detailAddress: "10층, 위워크 메일룸 디포스트",
    coords: [37.496, 127.028],
    call: "01080244805",
    time: {
      weekday: { startTime: "13:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 디자이너클럽",
    type: "Plus",
    address: "서울특별시 강남구 선릉로 818",
    detailAddress: " 6층, 위워크 메일룸 디포스트",
    coords: [37.5245, 127.0401],
    call: "01066524805",
    time: {
      weekday: { startTime: "13:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기", "포장용품판매"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 광화문",
    type: "Basic",
    address: "서울특별시 종로구 종로1길 50 케이트윈타워",
    detailAddress: "B동 2층, 디포스트 무인발송 스테이션",
    coords: [37.5746, 126.9791],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 강남역2",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로5길 7",
    detailAddress: "10층, 디포스트 무인발송 스테이션",
    coords: [37.4992, 127.0292],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 신사",
    type: "Basic",
    address: "서울특별시 강남구 강남대로 586",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.5142, 127.0205],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 신논현",
    type: "Basic",
    address: "서울특별시 서초구 서초대로77길 55 에이프로스퀘어",
    detailAddress: "6층, 디포스트 무인발송 스테이션",
    coords: [37.502, 127.0244],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 역삼역2",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로26길 14 대세빌딩",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.4992, 127.0359],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 홍대",
    type: "Basic",
    address: "서울특별시 마포구 양화로 147",
    detailAddress: "4층, 디포스트 무인발송 스테이션",
    coords: [37.5559, 126.922],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 서면",
    type: "Basic",
    address: "부산 진구 서전로 8 위워크 서면 3층,",
    detailAddress: "디포스트 무인발송 스테이션",
    coords: [35.157505, 129.060453],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["퀵"],
  },
  {
    logo: "wework",
    name: "디포스트 위워크 BIFC",
    type: "Basic",
    address: "부산 남구 전포대로 133 IFC부산 11층,",
    detailAddress: "디포스트 무인발송 스테이션",
    coords: [35.148416, 129.06564],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["퀵"],
  },
  {
    logo: "sparkplus",
    name: "디포스트 스파크플러스 선릉3",
    type: "Basic",
    address: "서울특별시 강남구 선릉로93길 40 나라키움역삼A빌딩",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.5046436441008, 127.045487348421],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "handsome",
    name: "디포스트 한섬 메일룸 청담",
    type: "Fit",
    address: "서울특별시 강남구 도산대로 523 한섬빌딩",
    detailAddress: "지하 1층, 디포스트",
    coords: [37.5249636616393, 127.050700596765],
    call: "01082184805",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "handsome",
    name: "디포스트 한섬 메일룸 성내",
    type: "Fit",
    address: "서울특별시 강동구 강동대로 197 (주)한섬 성내사옥 동관",
    detailAddress: "1층, 디포스트",
    coords: [37.5243220354972, 127.128514870456],
    call: "01075214805",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "genstarmate",
    name: "디포스트 KB우준타워",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로 447 KB우준타워",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.507, 127.0561],
    call: "1811-4232",
    time: {
      weekday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "genstarmate",
    name: "디포스트 스테이트타워 남산",
    type: "Fit",
    address: "서울특별시 중구 퇴계로 100, 스테이트타워 남산",
    detailAddress: "1층, 메일룸 디포스트",
    coords: [37.5601439201162, 126.982929217287],
    call: "01084454805",
    time: {
      weekday: { startTime: "08:00", endTime: "19:00" },
      lunch: { startTime: "13:00", endTime: "14:00" },
    },
    service: ["택배", "퀵", "등기", "포장용품판매"],
  },
  {
    logo: "blt",
    name: "디포스트 특허법인 비엘티",
    type: "Basic",
    address: "서울특별시 서초구 법원로3길 25 태흥빌딩",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.4928, 127.0079],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "",
    name: "디포스트 와이즈손보",
    type: "Basic",
    address: "서울특별시 종로구 종로5길 68 코리안리재보험빌딩",
    detailAddress: "와이즈손해보험중개 디포스트 무인발송 스테이션",
    coords: [37.5733692, 126.9804466],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "alexmuller",
    name: "디포스트 알렉스뮐러",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로 334",
    detailAddress: "지하 1층, 알렉스뮐러 디포스트 무인발송 스테이션",
    coords: [37.5039451, 127.0485253],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "visionport",
    name: "디포스트 비전포트",
    type: "Basic",
    address: "서울특별시 용산구 원효로90길 11 용산더프라임",
    detailAddress: "16층, 디포스트 무인발송 스테이션",
    coords: [37.5402697, 126.9700392],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "inno.n",
    name: "디포스트 HK이노엔 서초",
    type: "Basic",
    address: "서울특별시 서초구 사임당로 27 평환빌딩",
    detailAddress: "8층, 디포스트 무인발송 스테이션",
    coords: [37.4881515, 127.0131757],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배"],
  },
  {
    logo: "lgcns",
    name: "디포스트 CNS 메일센터",
    type: "Fit",
    address: "서울특별시 강서구 마곡중앙8로 71 LG사이언스파크",
    detailAddress: "E14 지하1층&3층, 디포스트",
    coords: [37.5618766, 126.8348243],
    call: "1811-4232",
    time: {
      weekday: { startTime: "07:30", endTime: "18:00" },
      lunch: { startTime: "12:00", endTime: "13:00" },
    },
    service: ["택배", "등기", "국제우편", "행낭"],
  },
  {
    logo: "dcamp",
    name: "디포스트 디캠프 선릉",
    type: "Basic",
    address: "서울특별시 강남구 선릉로 551 새롬빌딩",
    detailAddress: "2층, 디포스트 무인발송 스테이션",
    coords: [37.5077896, 127.0453474],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },

  {
    logo: "lgsports",
    name: "디포스트 LG스포츠 잠실점",
    type: "Basic",
    address: "서울 송파구 잠실동 10 서울종합운동장",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.515386, 127.072841],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "lgsports",
    name: "디포스트 LG챔피언스파크점",
    type: "Basic",
    address: "경기 이천시 대월면 부필리 543 LG이천 스포츠콤플렉스",
    detailAddress: "디포스트 무인발송 스테이션",
    coords: [37.228681, 127.505782],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "lgsports",
    name: "디포스트 LG스포츠 창원",
    type: "Basic",
    address: "경남 창원시 성산구 중앙동 1 경륜경기장",
    detailAddress: "디포스트 무인발송 스테이션",
    coords: [35.232158884092875, 128.66799638725522],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "genuonesciences",
    name: "디포스트 제뉴원 본사점",
    type: "Basic",
    address: "서울특별시 중구 세종대로 39 대한서울상공회의소",
    detailAddress: "5층 제뉴원사이언스, 디포스트 무인발송 스테이션",
    coords: [37.560529737976836, 126.97367408894445],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "genuonesciences",
    name: "디포스트 제뉴원 중앙연구소점",
    type: "Basic",
    address: "경기도 화성시 삼성1로2길 16",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.22132637926054, 127.07385100874224],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "genuonesciences",
    name: "디포스트 제뉴원 세종사업장점",
    type: "Basic",
    address: "세종특별자치시 전의면 산단길 245 제뉴원사이언스 세종사업장",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [36.69964754295323, 127.21902825158017],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "genuonesciences",
    name: "디포스트 제뉴원 제천사업장점",
    type: "Basic",
    address: "충청북도 제천시 바이오밸리2로 93",
    detailAddress: "1층, 디포스트 무인발송 스테이션",
    coords: [37.15236890632557, 128.1709798172587],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "shoplive",
    name: "디포스트 샵라이브코리아점",
    type: "Basic",
    address: "서울특별시 강남구 영동대로85길 34",
    detailAddress: "13층, 샵라이브코리아 디포스트 무인발송 스테이션",
    coords: [37.50675876770878, 127.06086749063876],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "goldenplanet",
    name: "디포스트 골든플래닛점",
    type: "Basic",
    address: "서울특별시 강남구 언주로 535 골든플래닛타워",
    detailAddress: "9층, 디포스트 무인발송 스테이션",
    coords: [37.50583035907782, 127.04079742509433],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },

  {
    logo: "qraft",
    name: "디포스트 QRAFT 파크원점",
    type: "Basic",
    address: "서울특별시 영등포구 여의대로 108 파크원",
    detailAddress:
      "타워2 27층, 크래프트테크놀로지스 디포스트 무인발송 스테이션",
    coords: [37.52707903770425, 126.92782841024066],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },

  {
    logo: "qraft",
    name: "디포스트 QRAFT IFC점",
    type: "Basic",
    address: "서울특별시 영등포구 국제금융로 10",
    detailAddress: "30층, 크래프트테크놀로지스 디포스트 무인발송 스테이션",
    coords: [37.52590454913181, 126.92631644549117],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "ridi",
    name: "디포스트 RIDI 아이콘역삼점",
    type: "Basic",
    address: "서울특별시 강남구 테헤란로44길 8",
    detailAddress: "14층 리디주식회사, 디포스트 무인발송 스테이션",
    coords: [37.50226781454227, 127.0444568735556],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
  {
    logo: "milimeal",
    name: "디포스트 밀리밀점",
    type: "Basic",
    address: "서울특별시 성동구 광나루로 160",
    detailAddress: "5층 밀리밀, 디포스트 무인발송 스테이션",
    coords: [37.551323801527346, 127.04782725415353],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "wtcseoul",
    name: "디포스트 아셈타워 메일센터점",
    type: "Fit",
    address: "서울특별시 강남구 영동대로 513 아셈타워",
    detailAddress: "1층, 메일센터 디포스트",
    coords: [37.51306858347876, 127.05982635326872],
    call: "01084414805",
    time: {
      weekday: { startTime: "08:00", endTime: "19:00" },
      saturday: { startTime: "10:00", endTime: "17:00" },
    },
    service: ["택배", "퀵", "등기", "국제우편"],
  },
  {
    logo: "shinhansec",
    name: "디포스트 신한투자증권점",
    type: "Fit",
    address: "서울특별시 영등포구 의사당대로 96 신한투자증권",
    detailAddress: "31층, 문서수발실",
    coords: [37.521726229194726, 126.92290991491795],
    call: "01075214805",
    time: {
      weekday: { startTime: "07:30", endTime: "17:30" },
    },
    service: ["택배", "퀵"],
  },
  {
    logo: "hanlim",
    name: "디포스트 한림제약점",
    type: "Basic",
    address: "서울특별시 서초구 서초대로52길 42 한림제약 본사",
    detailAddress: "",
    coords: [37.49187992060979, 127.01455023152536],
    call: "1811-4232",
    time: {
      weekday: { startTime: "09:00", endTime: "18:00" },
    },
    service: ["택배", "퀵", "등기"],
  },
];
